import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const BorderCount = () => {
    const { t } = useTranslation();
    const [hasAnimated, setHasAnimated] = useState(false);
    const [counters, setCounters] = useState([0, 0, 0, 0]);
    const sectionRef = useRef(null);
    
    const dataItems = [
        {
            target: 125000,
            suffix: '+',
            description: t('borderCount.activeInvestors'),
        },
        {
            target: 2500,
            suffix: 'B+',
            description: t('borderCount.tradingVolume'),
        },
        {
            target: 50000,
            suffix: '+',
            description: t('borderCount.dailyTransactions'),
        },
        {
            target: 150,
            suffix: '+',
            description: t('borderCount.supportedCoins'),
        },
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !hasAnimated) {
                    setHasAnimated(true);
                    animateCounters();
                    observer.disconnect();
                }
            },
            { threshold: 0.2 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [hasAnimated]);

    const animateCounters = () => {
        const duration = 2000; // 2 saniye
        const steps = 60;
        const stepDuration = duration / steps;

        dataItems.forEach((item, index) => {
            let currentStep = 0;
            const increment = item.target / steps;

            const timer = setInterval(() => {
                currentStep++;
                if (currentStep <= steps) {
                    setCounters((prev) => {
                        const newCounters = [...prev];
                        newCounters[index] = Math.min(increment * currentStep, item.target);
                        return newCounters;
                    });
                } else {
                    clearInterval(timer);
                }
            }, stepDuration);
        });
    };

    const formatNumber = (num, index) => {
        const item = dataItems[index];
        if (item.suffix === 'B+') {
            return (num / 1000).toFixed(1);
        }
        return Math.floor(num).toLocaleString();
    };

    return (
        <div className='border-count-content' ref={sectionRef}>
            <div className='container'>
                <div className="row">
                    {
                        dataItems.map((item, index) => (
                            <div className="col-lg-3 col-md-3" key={index}>
                                <div className="border-count-content-item">
                                    <h3>{formatNumber(counters[index], index)}{item.suffix}</h3>
                                    <p className='mb-0'>{item.description}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default BorderCount